import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBZBHRoP9_JVOXJ2gr3DN6m3noNnmELqhM",
  authDomain: "ordenes-itacate-minero-95341.firebaseapp.com",
  projectId: "ordenes-itacate-minero-95341",
  storageBucket: "ordenes-itacate-minero-95341.appspot.com",
  messagingSenderId: "203628358775",
  appId: "1:203628358775:web:cfb0da457055d738b3aa72",
  measurementId: "G-8PW3PNK89J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Exporta la instancia de Firestore para usarla en otros componentes
export const db = getFirestore(app);
export const auth = getAuth(app);